import fp from 'lodash/fp';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, lifecycle, renderComponent, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { defaultTake } from '../../../../../../constants';
import { fullName } from '../../../../../../services';
import { adminActions } from '../../../../../../state/modules/admin';
import { LoadingButton, Pill, SearchForm } from '../../../../../components';
import Loading from '../../../../loading';

const UserSelection = ({ isFetchingUser, fetchUsersQuery, onSearchUsers, onLoadMoreUsers, hasMore, selectedUsers, searchResult }) => {
  return <div id='user-selection'>
    <Row className='no-gutter'>
      <Col md={3} sm={12}>
        <SearchForm disabled={selectedUsers.length > 0} label="Search users" searchQuery={fetchUsersQuery.tags} onSearchChange={onSearchUsers} />
      </Col>
    </Row>
    <div className='boxed'>
      {
        searchResult
      }
    </div>
    {
      hasMore ?
        <LoadingButton text='Load More' loading={isFetchingUser} onClick={onLoadMoreUsers} /> :
        null
    }
  </div>
}

const mapStateToProps = (state) => ({
  isFetchingUser: state.admin.isFetchingUser,
  userData: state.admin.userData,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: bindActionCreators(adminActions.admin.getUsers, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      fetchUsersQuery: {
        skip: 0,
        take: defaultTake,
        tags: ''
      },
      searchDebounce: undefined,
    },
    {
      updateSearchDebounce: () => (searchDebounce) => ({ searchDebounce }),
      onSearchUsers: ({ fetchUsersQuery }) => (e) => ({
        fetchUsersQuery: {
          ...fetchUsersQuery,
          skip: 0,
          tags: e.target.value
        }
      }),
      onLoadMoreUsers: ({ fetchUsersQuery }) => () => ({
        fetchUsersQuery: {
          ...fetchUsersQuery,
          skip: fetchUsersQuery.skip + defaultTake
        }
      })
    }
  ),
  withStateHandlers(
    {
      selectedUsers: []
    },
    {
      toggleUser: ({ selectedUsers }) => (user) => {
        if (fp.includes(user)(selectedUsers)) {
          return {
            selectedUsers: fp.difference(selectedUsers)([user])
          }
        } else {
          return {
            selectedUsers: [user]
          }
        }
      }
    }
  ),
  lifecycle({
    componentDidMount() {
      const {
        fetchUsersQuery,
        getUsers
      } = this.props
      getUsers(fetchUsersQuery)
    },
    componentDidUpdate(prevProps) {
      const {
        fetchUsersQuery,
        getUsers,
        searchDebounce,
        updateSearchDebounce,
        selectedUsers,
        onChange
      } = this.props

      if (!fp.isEqual(prevProps.fetchUsersQuery, fetchUsersQuery)) {
        const debounced = fp.debounce(500)(
          () => {
            getUsers(fetchUsersQuery)
          }
        );
        updateSearchDebounce(debounced);
        searchDebounce && searchDebounce.cancel();
        debounced();
      }

      if (!fp.isEqual(selectedUsers)(prevProps.selectedUsers)) {
        onChange(selectedUsers)
      }

    }
  }),
  branch(
    ({ userData }) => !userData,
    renderComponent(Loading)
  ),
  withProps(
    ({ userData, selectedUsers, toggleUser }) => ({
      hasMore: userData.result.length < userData.hits,
      selectedUserRows: fp.map(
        (user) => <div key={user.id}>{fullName(user)}</div>
      )(selectedUsers),
      searchResult: fp.map(
        ({ user }) => {
          const isUserSelected = fp.includes(user)(selectedUsers)
          return <Pill key={user.id} label={fullName(user)} checked={isUserSelected} onChange={
            () => toggleUser(user)
          } />
        }
      )(userData.result)
    })
  ),
)(UserSelection)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/components/userSelection.js